/** Start pledge */
$(document).on('submit', '.make-pledge-form', function(e) {
  e.preventDefault();

  $.ajax({
    url: customSettings.ajaxurl,
    method: 'POST',
    data: {
      action: 'make_pledge',
      id: customSettings.current_id,
      user_id: customSettings.current_user,
      _wpnonce: $(this).find('[name="_wpnonce"]').val()
    },
    dataType: 'json',
    success: function(response) {
      if (response.status === 'success') {
        window.location.reload(true);
      }
    }
  });
});

/** Update pledge subtask */
$(document).on('click', '.update-subtask [type="submit"]', function(e) {
  e.preventDefault();

  var $form = $(this).parents('form.update-subtask'),
    milestones = $form.parents('.pledge-actions');
    
  $form.find('[type="submit"]').removeClass('btn-icon').addClass('icon-right').append('<i class="fas fa-spinner fa-spin"></i>');

  var data = {
    description: $form.find('[name="description"]').length > 0 ? $form.find('[name="description"]').val() : null,
    action: 'update_pledge_subtask',
    status: $form.find('[name="status"]').val(),
    pledge_id: $form.find('[name="pledge_id"]').val(),
    uid: $form.find('[name="uid"]').val(),
    user_id: customSettings.current_user,
    _wpnonce: $form.find('[name="_wpnonce"]').val()
  };

  $.ajax({
    url: customSettings.ajaxurl,
    method: 'POST',
    data: data,
    dataType: 'json',
    success: function(response) {
      $form.find('[type="submit"]').addClass('btn-icon').removeClass('icon-right');
      $form.find('[type="submit"] i').remove();
      
      if (response.status === 'success') {
        milestones.append('<div class="reloading"><div class="message">Updating milestones <i class="fas fa-spinner fa-spin"></i></div></div>');
        $('.modal').modal('hide');
        getActionList(milestones, true);
      } else {
        $form.find('.modal-footer').append('<span class="submit-message error">'+response.message+'</span>');

        setTimeout(function() {
          $form.find('.modal-footer .submit-message').fadeOut();
        }, 3000);
      }
    }
  });
});

/** Get action list */
if ($('.pledge-actions').length === 1) {
  getActionList($('.pledge-actions'), false);
} else if ($('.pledge-actions').length > 1) {
  $('.pledge-actions').each(function() {
    getActionList($(this), false);
  });
}

function getActionList($this, user_updated) {
  var nonce = $this.attr('data-nonce');

  if (customSettings.current_id && customSettings.current_user) {
    $.ajax({
      url: customSettings.ajaxurl,
      method: 'GET',
      data: {
        pledge_id: customSettings.current_id,
        user_id: customSettings.current_user,
        action: 'get_pledge_milestones',
        _wpnonce: nonce
      },
      dataType: 'json',
      success: function(response) {
        if ($('.stat .large-number').length > 0) {
          $('.stat .completion-number').text(response.data.completion);
          $('.progress-bar .progress-inner').css({
            'width': response.data.completion+'%'
          });
        }

        if ($('.pledge-status-bar').length > 0) {
          if (response.data.completion === '100') {
            /** Show the confetti */
            if (user_updated) {
              $(window).scrollTop(0);
              $('body').addClass('confetti-show');
            }

            $('.pledge-status-bar .badge-wrapper').html('<span class="badge bg-century-blue text-uppercase">Complete</span>');
          } else if (response.data.completion === '0' && response.data.has_started === false) {
            $('.pledge-status-bar .badge-wrapper').html('<span class="badge bg-secondary">Not started</span>');
          } else {
            $('.pledge-status-bar .badge-wrapper').html('<span class="badge bg-mid-blue text-uppercase">In progress</span>');
          }
        }

        /** Render list */
        $this.html('').html(response.data.body);
        $('form').validate(validationBody);
      }
    });
  }
}

/** Carousel */
$('.pledges-in-progress-wrapper').each(function() {
  var $carousel = $(this).find('.pledges-in-progress'),
    slideCount = $carousel.find('.pledge-item').length;

  $carousel.owlCarousel({
    items: 1,
    loop: slideCount > 1 ? true : false,
    autoHeight: true,
    nav: slideCount > 1 ? true : false,
    dots: slideCount > 1 ? true : false,
    margin: 10,
    mouseDrag: slideCount > 1 ? true : false,
    touchDrag: slideCount > 1 ? true : false,
    pullDrag: slideCount > 1 ? true : false,

    navContainer: $(this).find('.custom-nav .nav'),
    dotsContainer: $(this).find('.custom-nav .dots'),
  });
});

$('.action-select').on('change', function() {
    let val = $(this).find('option:selected').val();
    
    $(this).closest('.pledge-grid-item__log-action').find('i').addClass('hidden');

    if(val == 2) {
        $(this).closest('.pledge-grid-item__log-action').find('i.fa-circle-check').removeClass('hidden');
    }

    if(val == 3) {
        $(this).closest('.pledge-grid-item__log-action').find('i.fa-hourglass').removeClass('hidden');
    }

    if(val == 2024 || val == 2025 || val == 2026 || val == 2027 || val == 2028 || val == 2029 || val == 2030) {
        $(this).closest('.pledge-grid-item__log-action').find('i.fa-calendar-days').removeClass('hidden');
    }

    if(val == 5) {
        $(this).closest('.pledge-grid-item__log-action').find('i.fa-xmark').removeClass('hidden');
    }
})